import $ from 'jquery';

const menu = () => {

    let prevScrollPos = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScrollPos = window.scrollY;
        if (window.innerWidth > 768) {
            if (prevScrollPos > currentScrollPos) {
                document.querySelectorAll('header')[0].classList.remove('fixe');
            } else {
                document.querySelectorAll('header')[0].classList.add('fixe');
            }

            // update previous scroll position
            prevScrollPos = currentScrollPos;
        }
    })


    // MENU MOBILE
    $('a[href^="#"]').click(function () {
        const the_id = $(this).attr("href");

        if (the_id !== '#') {
            $('html, body').animate({
                scrollTop: ($(the_id).offset().top - 190)
            }, 'fast');
            return false;
        }
    });

    if ($(window).width() <= 768) {
        $('.button-menu').on('click', function () {
            $(this).find('.hamburger').toggleClass('is-active');
            $('header').toggleClass('active');
            $('.header-fixed').toggleClass('active');
            $('header nav').toggleClass('active');
        });

        $('.menu-item-has-children > a').on('click', function () {
            $(this).toggleClass('active');
            $(this).parent().toggleClass('active');
            return false;
        });
    }
}

export default menu;